
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    text: String,
  },
})
export default class CourseCardButton extends Vue {}
